import {isMobileApp} from "../../../../misc/envNameUtils.ts";

export const handleTextChunk = (message: any, currentMessageRef: any, environmentObjRef: any, llmRequestRefs: any, setMessages: any) => {
    if (llmRequestRefs.current.intervalId) {
        clearInterval(llmRequestRefs.current.intervalId);
        llmRequestRefs.current.intervalId = null;
        currentMessageRef.current.message = {
            ...currentMessageRef.current.message,
            content: []
        };
    }

    let updatedContent = [...currentMessageRef.current.message.content];

    // Create the new content block for the output stream if needed. For first stream chunk, either there is no content or the content is Claude's CoT
    if (updatedContent.length === 0 || updatedContent[updatedContent.length - 1].type !== "text") {
        updatedContent.push({type: "text", "text": message.chunk + '●'});
    } else {
        const lastIndex = updatedContent.length - 1;
        const currentText = updatedContent[lastIndex]?.text || '';
        updatedContent[lastIndex] = {
            type: "text",
            "text": currentText.slice(0, -1) + message.chunk + '●'
        };

        if (isMobileApp(environmentObjRef.current.environment) && message.chunk.includes("\n")) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                functionName: "triggerHapticFeedback",
                data: [{_: '_'}]
            }));
        }
    }

    currentMessageRef.current.message = {
        ...currentMessageRef.current.message,
        content: updatedContent
    };

    setMessages((prev: any) => prev.deepCopy());
}